import React from 'react'
import {
  Modal,
  useModal,
  ModalTransition,
} from 'react-simple-hook-modal';
import 'react-simple-hook-modal/dist/styles.css';



export default function CieModal({ key, className,  id,  content_add, open, content}) {
  const { isModalOpen, openModal, closeModal } = useModal();

  return (
    <>
        <div key={ key ? `cieModal__${ key}` : 'cieModal' } className="is-clickable" onClick={openModal} dangerouslySetInnerHTML={{ __html:  open }} />
        <Modal
          isOpen={isModalOpen}
          onBackdropClick={closeModal}
          transition={ModalTransition.BOTTOM_UP}
        >
        <div id={id} className={`${className ? className : ''}`} >
            <div className='ciemodal__close_container'>
                <button className={`ciemodal__close modal-close is-large`} onClick={closeModal} aria-label="close" ></button>
            </div>
            {
               content && <div dangerouslySetInnerHTML={{ __html: content }} />

            }

              {
            content_add && <div class="content-add column is-12">{content_add}</div>
              }

          </div>
        </Modal>
    </>
  )
}
